import React, { useEffect } from "react";
import confetti from "canvas-confetti";

/**
 * Fires a confetti burst whenever `trigger` transitions to true.
 * Resets the fired flag when `trigger` becomes false.
 */
export function ConfettiCelebration({ trigger }) {
  const firedRef = React.useRef(false);

  useEffect(() => {
    if (trigger && !firedRef.current) {
      firedRef.current = true;
      confetti({
        particleCount: 140,
        spread: 90,
        origin: { x: 0.5, y: 0.55 },
        colors: ["#C17F59", "#F9F6F0", "#DCD4C6", "#8B5E34", "#2B2623"],
        ticks: 250,
      });
    }
    if (!trigger) {
      firedRef.current = false;
    }
  }, [trigger]);

  return null;
}
